<template>
  <div>
    <div class="wrap"></div>
    <div id="document">
      <DirectIncomingRB v-if="direct.category === 'incoming' && (rb === '1А' || rb === '2А')"/>
      <DirectIncoming v-else-if="direct.category === 'incoming'"/>
      <DirectOutgoingRB v-if="direct.category === 'outgoing' && rb === '3А'"/>
      <DirectOutgoing v-else-if="direct.category === 'outgoing'"/>
      <DirectAppeal v-if="direct.category === 'appeal'"/>
      <div class="qr">
        {{$t('direct.qr')}}:
        <img :src="qr"/>
      </div>
      <div class="is-clearfix"></div>
    </div>
  </div>
</template>

<script>
  import {mapState} from 'vuex'
  import {HOST} from '@/localSettings'
  import QRCode from 'qrcode'
  import DirectIncoming from '@/components/DirectIncoming'
  import DirectIncomingRB from '@/components/DirectIncomingRB'
  import DirectOutgoing from '@/components/DirectOutgoing'
  import DirectOutgoingRB from '@/components/DirectOutgoingRB'
  import DirectAppeal from '@/components/DirectAppeal'

  export default {
    components: {
      DirectOutgoing,
      DirectOutgoingRB,
      DirectIncoming,
      DirectIncomingRB,
      DirectAppeal
    },
    data() {
      return {qr: null}
    },
    mounted() {
      this.$store.dispatch('Docflow/getDocumentByHash', this.$route.params.hash)
      QRCode.toDataURL(`${HOST}direct/${this.$route.params.hash}`).then((qr) => this.qr = qr)
    },
    computed: {
      ...mapState('Docflow', ['direct']),
      rb() {
        return this.direct.register_book__name
      }
    }
  }
</script>

<style scoped lang="scss">
  .wrap {
    background: #f4f5fa;
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    z-index: -1;
  }

  #document {
    width: 800px;
    margin: 50px auto;
    background: #fff;
    padding: 40px 60px;
    box-shadow: -10px 9px 21px rgba(128, 152, 213, 0.074983);
  }

  .qr {
    width: 200px;
    font-size: 14px;
    color: #888;
    font-style: italic;
    img {
      display: block;
      position: relative;
      left: -15px;
    }
  }
</style>
